export default {
    firstName: (state) => state.firstName,
    lastName: (state) => state.lastName,
    email: (state) => state.email,
    phone: (state) => state.phone,
    companyName: (state) => state.companyName,
    fleetSize: (state) => state.fleetSize,
    state: (state) => state.state,
    country: (state) => state.country,
    account: state => state,
}